export default "__VITE_ASSET__DFVy19s9__"